import { useSelector } from "react-redux";

import { getImage } from "../../../utils/utils";
import ImageContainer from "../../shared/ImageContainer";
import BusinessImageContainer from "./BusinessImageContainer";

const BussinessDetail = () => {
  const activeBusiness = useSelector((store) => store.bussinessSlice.data);

  const business = activeBusiness.business;
  const is_real = business?.business_type === "real";

  // profile & document images
  const logoImage = getImage(business?.logo_preview);
  const businessLicenseImage = getImage(business?.business_license_image_preview);
  const announcementImage = getImage(business?.announcement_image_preview);
  const lastAnnouncementImage = getImage(business?.last_announcement_image_preview);

  return (
    <div className="mx-auto mt-2 h-full w-fit flex-col gap-4 overflow-auto rounded-[16px] bg-white p-4">
      <div className="bg-primary-100 mx-auto mb-4 w-fit rounded-full p-0.5 shadow-xl">
        <BusinessImageContainer
          className={"rounded-full"}
          src={getImage(logoImage)}
          width={"150px"}
          heigh={"150px"}
          businessId={business.id}
          businessType={business.business_type}
        />
      </div>

      {/* Profile info */}
      <section className="w-full">
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-2">
          {/* ➕ New cards */}
          <ProfileCard title="نام کسب و کار (فارسی)*" value={activeBusiness?.business?.fa_name} />
          <ProfileCard title="نام کسب وکار (انگلیسی)*" value={activeBusiness?.business?.en_name} />
          <ProfileCard title="نشانی" value={activeBusiness?.business?.address} />
          <ProfileCard title="تلفن ثابت" value={activeBusiness?.business?.phone} />
          <ProfileCard title="کدپستی" value={activeBusiness?.business?.postal_code} />
          <ProfileCard
            title={`کد مالیاتی  ${is_real ? "(اختیاری)" : ""}`}
            value={activeBusiness?.business?.tax_code}
          />
          {!is_real && (
            <>
              <ProfileCard title={"شناسه ملی"} value={activeBusiness?.business?.national_id} />
              <ProfileCard title={"شماره ثبت"} value={activeBusiness?.business?.register_code} />
              {/* <ProfileCard
                title={"تاریخ ثبت"}
                value={toPersianDate(activeBusiness?.business?.register_date)}
              /> */}
            </>
          )}

          <ProfileCard title={"حساب بانکی"} value={activeBusiness?.account?.name} />
          <ProfileCard title={"صنف"} value={activeBusiness?.category?.business_category_code_title} />
        </div>
      </section>

      {/* Uploaded documents */}
      <section className="mt-6 flex flex-col gap-2">
        <p className="text-sm font-semibold">مدارک بارگذاری شده</p>

        <div className="flex w-full gap-1">
          {!is_real && (
            <>
              <DocumentCard label="آگهی  تاسیس" src={announcementImage} />

              <DocumentCard label="آگهی آخرین تغییرات" src={lastAnnouncementImage} />
            </>
          )}
          <DocumentCard label="جواز کسب" src={businessLicenseImage} />
        </div>
      </section>
    </div>
  );
};

export default BussinessDetail;

const DocumentCard = ({ label, src }) => (
  <div className="flex flex-col gap-2 p-2">
    <p className="text-neutral-40 text-xs font-semibold">{label}</p>
    {src && <ImageContainer src={src} width="150px" height="150px" />}
  </div>
);

const ProfileCard = ({ title, value }) => {
  return (
    <div className="min-w-[280px] space-y-1">
      <p className="text-[14px] font-semibold text-[#4e4d4d] md:text-[16px]">{title}</p>
      <div className="flex min-h-[40px] w-full items-center justify-between rounded-[10px] border-[1px] border-gray-300 bg-white p-[6px]">
        <p className="truncate text-[14px] text-[#2c2c2c] md:text-[16px]" title={value ?? "-"}>
          {value ?? "-"}
        </p>
      </div>
    </div>
  );
};
